import { Typography, Paper } from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";
import { useMemo } from "react";
import "../../assets/style/StakePage.css";

import StakeCard from "../StakePage/StakeCard";

import BtcIcons from "../../assets/img/icons/btc.png";
import EtheriumIcon from "../../assets/img/icons/eth.png";
import TetherUSDTIcon from "../../assets/img/icons/usdt.png";
import BNBIcon from "../../assets/img/icons/bnb.png";
import SolanaIcon from "../../assets/img/icons/sol.png";
import XRPIcon from "../../assets/img/icons/xrp.png";
import CardanoIcon from "../../assets/img/icons/ada.png";
import DogecoinIcon from "../../assets/img/icons/doge.png";
import LitecoinIcon from "../../assets/img/icons/ltc.png";
import MoneroIcon from "../../assets/img/icons/xmr.png";
import PolygonIcon from "../../assets/img/icons/matic.png";
import TRONIcon from "../../assets/img/icons/trx.png";
import USDIcon from "../../assets/img/icons/usd.png";
import EURIcon from "../../assets/img/icons/eur.png";

const CurrencyIcon = ({ img }) => (
  <div className="currency-icon-placeholder">
    <img src={img} alt="" />
  </div>
);

export default function StakePage() {
  const { t, currentLanguage } = useLanguage();

  // Создаем опции с помощью useMemo для автоматического обновления при смене языка
  const currencies = useMemo(() => {
    return [
      { symbol: "BTC", name: t('bitcoinStake'), icon: <CurrencyIcon img={BtcIcons} /> },
      {
        symbol: "ETH",
        name: t('ethereumStake'),
        icon: <CurrencyIcon img={EtheriumIcon} />,
      },
      {
        symbol: "USDT",
        name: t('tetherUsdtStake'),
        icon: <CurrencyIcon img={TetherUSDTIcon} />,
      },
      { symbol: "BNB", name: t('bnbStake'), icon: <CurrencyIcon img={BNBIcon} /> },
      { symbol: "SOL", name: t('solanaStake'), icon: <CurrencyIcon img={SolanaIcon} /> },
      { symbol: "XRP", name: t('xrpStake'), icon: <CurrencyIcon img={XRPIcon} /> },
      {
        symbol: "ADA",
        name: t('cardanoStake'),
        icon: <CurrencyIcon img={CardanoIcon} />,
      },
      {
        symbol: "DOGE",
        name: t('dogecoinStake'),
        icon: <CurrencyIcon img={DogecoinIcon} />,
      },
      {
        symbol: "LTC",
        name: t('litecoinStake'),
        icon: <CurrencyIcon img={LitecoinIcon} />,
      },
      { symbol: "XMR", name: t('moneroStake'), icon: <CurrencyIcon img={MoneroIcon} /> },
      {
        symbol: "MATIC",
        name: t('polygonStake'),
        icon: <CurrencyIcon img={PolygonIcon} />,
      },
      { symbol: "TRX", name: t('tronStake'), icon: <CurrencyIcon img={TRONIcon} /> },
      { symbol: "USD", name: t('usdStake'), icon: <CurrencyIcon img={USDIcon} /> },
      { symbol: "EUR", name: t('eurStake'), icon: <CurrencyIcon img={EURIcon} /> },
    ];
  }, [t, currentLanguage]);

  return (
    <div style={{ padding: '24px' }}>
      <div className="stake-cards-grid">
        {currencies.map((currency, index) => (
          <StakeCard key={`${currentLanguage}-${currency.symbol}-${index}`} currency={currency} />
        ))}
      </div>
    </div>
  );
}
